module.exports = __webpack_public_path__ + "static/img/dummy3.794101d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/dummy3.png
// module id = qm1e
// module chunks = 1